var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@purpurds/purpur/button';
import { Icon } from '@purpurds/purpur/icon';
import styled from 'styled-components';
const StyledIcon = styled(Icon) `
  color: inherit;
  margin-right: ${props => (props.$rightMargin ? '0.5rem' : 0)};
  margin-left: ${props => (props.$leftMargin ? '0.5rem' : 0)};
`;
export const PurPurButton = (_a) => {
    var { children, iconSize = 'sm', leftIcon, rightIcon } = _a, props = __rest(_a, ["children", "iconSize", "leftIcon", "rightIcon"]);
    return (_jsxs(Button, Object.assign({}, props, { children: [leftIcon && _jsx(StyledIcon, { svg: leftIcon, size: iconSize, "$rightMargin": true }), children, rightIcon && _jsx(StyledIcon, { svg: rightIcon, size: iconSize, "$leftMargin": true })] })));
};
